import styled, { css } from 'styled-components';
import { rem } from 'polished';

import { Card } from '@interstate/components/Card';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import type { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

type Theme = ReturnType<typeof useInterstateTheme>;

const DeskingCardsContainer = styled.div<{ cardsAmount: number; isDealCentralExperience?: boolean; theme?: Theme }>`
    display: grid;
    overflow: auto;
    grid-auto-flow: column;
    grid-gap: ${({ theme }) => theme.tokens.ComponentCardPadding};
    grid-template-columns: ${({ cardsAmount }) => `repeat(${cardsAmount}, minmax(30rem, 1fr));`};
    grid-template-rows:
        [header] auto
        [payment-details] auto
        [terms] auto
        [paymentGrid] auto
        [creditBureau] auto
        [trade] auto
        [tax] auto
        [fees] auto
        [rebates] auto
        [vpp] auto
        [accessories] auto
        [comments] auto
        [actions] auto;

    margin: 0;

    ${({ isDealCentralExperience }) =>
        isDealCentralExperience &&
        css`
            margin-top: 0;
            grid-auto-flow: row;
            grid-template-rows: none;
        `}

    @media (max-width: ${BreakPoint.PHONE}) {
        grid-template-columns: ${({ cardsAmount }) => `repeat(${cardsAmount}, minmax(26.7rem, 1fr));`};
    }
`;

export const DeskingCardsContainerCompact = styled(DeskingCardsContainer)`
    grid-gap: 0.5rem;
    grid-template-columns: ${({ cardsAmount }) => `repeat(${cardsAmount}, minmax(var(--desking-card-min-width, 33rem), 1fr));`};
    overflow: visible;

    @media (max-width: ${BreakPoint.PHONE}) {
        grid-template-columns: ${({ cardsAmount }) => `repeat(${cardsAmount}, minmax(26.7rem, 1fr));`};
    }
`;

export const CompactDealCentralCardHeaderActions = styled.div<{ theme: Theme }>`
    display: grid;
    grid-template-columns: 0.5fr 8fr;
    grid-template-rows: minmax(0.714rem, 1fr);
    align-items: center;
    border-bottom: 1px solid ${({ theme }) => theme.tokens.SemColorBorderDefault};
    padding-bottom: 0.5rem;
    padding-top: 0.286rem;
    margin-bottom: 0.5rem;
`;

export const DeskingCardSelectDraftDeal = styled.div`
    margin-bottom: -0.6rem;
`;

export const DeskingCardHeaderActionsMenu = styled.div`
    justify-self: end;
    grid-column: 2 / -1;
    margin-bottom: -0.5rem;

    & * {
        margin-left: 8px;
    }
`;

export const StretchHeightCard = styled(Card)<{
    containername?: string;
}>`
    .MuiCardHeader-action {
        margin-right: 0;
    }
    &.stretch-height-card {
        background-color: inherit;
    }

    & > * {
        height: 100%;

        & > * {
            height: 100%;
        }
    }

    /* base deal screen styles - always applied */
    border: none !important;
    overflow: visible !important;

    .card-header-content-container {
        padding: 0 !important;
        margin-top: ${rem(5)} !important;
    }

    .base-tab-title {
        font-size: ${rem(23)} !important;
    }
`;

export const LoadingSection = styled.div`
    position: relative;
    height: 100%;
`;

export const FeesCardHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    [id$='capitalize-all-fees-id'] {
        align-items: center;
    }
`;
